module.exports = __webpack_public_path__ + "static/media/azure_sc900_logo.89c89e15.png";